import { api } from './index';

export default {
  getTermCondition(section) {
    if (section) {
      return api.get(`/terms_and_conditions?section=${section}`);
    } else {
      return api.get(`/terms_and_conditions`);
    }
  },
  updateTermCondition(payload) {
    return api.put(`/terms_and_conditions`, {
      terms_and_conditions: payload,
    });
  },
};
